import React from "react";
import icon from "../../../assets/vp-personal-detail-icon.png";
import VPPersonalViewCC from "./VPPersonalViewCC";

function VPPersonalDetails({ userInfo }) {
  return (
    <div className="vp-supplier-type mb-3">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center">
            <img width={15.647} height={20} src={icon} alt="icon" />
            <h5 className="m-0 ms-2 vp-supplier-type-title">
              Personal details
            </h5>
          </div>
        </div>
        <div className="card-body">
          <div className="d-flex flex-column w-100 gap-2">
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Full name</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier_user_full_name}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Job Title</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.designation?.designation_name}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Phone Number</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.supplier_phone_number}
              </p>
            </div>
            <div className="d-flex flex-column align-items-start gap-2 justify-content-start">
              <p className="m-0 p-0 vp-pd-list-item-text-1">
                Company registration certificate
              </p>
              <VPPersonalViewCC
                fileName={userInfo?.data?.supplier?.company_registration_certificate
                  ?.split("/")
                  .pop()}
                fileUrl={
                  userInfo?.data?.supplier?.company_registration_certificate
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VPPersonalDetails;
